class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    // When this mega menu opens, close any other open mega menu in the SAME
    // frame. This keeps at least one menu open through a switch (e.g. Collection
    // -> About), so the header never passes through an "all closed" state that
    // would flicker the logo, the overlay and the white background (the clip).
    if (this.mainDetailsToggle.open) {
      document.querySelectorAll('header-menu details[open]').forEach((details) => {
        if (details !== this.mainDetailsToggle) details.removeAttribute('open');
      });
    }

    if (!this.header) return;
    // Keep the header pinned while ANY mega menu is open (the <details> toggle
    // event is async, so base the flag on the current open state, not just this one).
    this.header.preventHide = document.querySelector('header-menu details[open]') != null;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onFocusOut() {
    setTimeout(() => {
      const active = document.activeElement;
      // If focus moved to another mega menu, this is a switch: don't close here.
      // The other menu's open handler will close this one, so we never create a
      // gap where no menu is open (which is what causes the clip).
      const targetMenu = active && active.closest && active.closest('header-menu');
      if (targetMenu && targetMenu !== this) return;
      if (!this.contains(active)) this.close();
    });
  }
}

customElements.define('header-menu', HeaderMenu);
